export default {
  state: () => ({
    email: "",
  }),
  getters: {
    getEmail: (state) => {
      return state.email;
    },
  },
  mutations: {
    setEmail(state, data) {
      state.email = data;
    },
  },
  actions: {
    updateEmail({ commit }, data) {
      commit("setEmail", data);
    },
  },
  namespaced: true,
};
